import { ArrayHelper } from 'lib_ts/classes/array.helper';
import { MiscHelper } from 'lib_ts/classes/misc.helper';
import { MainService } from 'services/main.service';

const ROWS_PER_FILE = 500;

export class CsvExportHelper {
  static async saveCsv(
    data: any[],
    options: {
      prefix: string;
      maxRows?: number;
    }
  ) {
    if (data.length === 0) {
      return;
    }

    const maxRows = options.maxRows ?? ROWS_PER_FILE;

    // only one file is needed
    if (data.length <= maxRows) {
      const csvString = await MainService.getInstance().convertJSONToCSV(data);
      const blob = new Blob([csvString], { type: 'text/csv' });

      MiscHelper.saveAs(blob, `${options.prefix}.csv`);
      return;
    }

    /** split rows into separate files to avoid exceeding server payload limits */
    const chunks = ArrayHelper.chunkArray(data, maxRows);

    // split the data into multiple files
    for (let i = 0; i < chunks.length; i++) {
      const csvString = await MainService.getInstance().convertJSONToCSV(
        chunks[i]
      );

      const blob = new Blob([csvString], { type: 'text/csv' });

      const start = i * maxRows + 1;
      const end = Math.min((i + 1) * maxRows, data.length);

      MiscHelper.saveAs(blob, `${options.prefix}_${start}-${end}.csv`);
    }
  }
}
